import { createContext, useContext, useState } from 'react';
import { useLocation, useNavigate, Navigate, Outlet } from 'react-router-dom';


//
// Create a context to store our authorization information within
//
const AuthContext = createContext(null);

//
// Provide the AuthProvider which includes a place to save the user information
//  
export function AuthProvider({ 
    children,
    logoutPath = '', //this takes us to the home page index route
}) {
    let navigate = useNavigate();

    let [user, setUser] = useState(JSON.parse(sessionStorage.getItem('user')));
  
    let signin = async (userInfo, callback) => {
        setUser(userInfo);
        sessionStorage.setItem('user', JSON.stringify(userInfo));
        if (typeof callback === 'function') {
            callback();
        }
    };
  
    let signout = (callback) => {
        setUser(null);
        sessionStorage.removeItem('user');
        if (typeof callback === 'function'){
            callback();
        }
        navigate(logoutPath, { replace: true });
    };
  
    let value = { user, signin, signout };
  
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

//
// Simplified method of getting to the consumer context information by simply calling
//  const { user, signin, signout } = useAuth();
//  in the application
//
export function useAuth() {
    return useContext(AuthContext);
}

//
// Wrapper that ensures the user is logged in prior to accessing anything located between
//  <RequireAuth>
//     protected routes go here
//  </RequiredAuth>
//
export function RequireAuth({ 
    loginPath = '/#signin',
}) {
    let auth = useAuth();
    let location = useLocation();
  
    if (!auth.user) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to={loginPath} state={{ from: location }} replace />;
    }
  
    return <Outlet />;
}




